import { inject } from "vue";

export default function reusableBase() {
  const moment = inject("$moment");

  // Format any date in Philippine Time
  const greetingMessage = (val) => {
    const date = val ? moment(val) : moment(); // use now if no value
    return date.tz("Asia/Manila").format("LL"); // 'LL' => February 11, 2026
  };

  const greeting = () => {
    const savedLanguage = localStorage.getItem("language") || "en";
    const hour = moment().tz("Asia/Manila").hour();
    if (hour < 12)
      return savedLanguage === "en" ? "Good morning" : "Magandang umaga";
    if (hour < 18)
      return savedLanguage === "en" ? "Good afternoon" : "Magandang hapon";
    return savedLanguage === "en" ? "Good evening" : "Magandang gabi";
  };

  const todayGreeting = () => `${greeting()}`;

  const dateFormatMonthDateYear = (val) => {
    const date = val ? moment(val) : moment();
    return date.tz("Asia/Manila").format("LL");
  };
  const amountFormat = (val) => {
    return (
      "PHP " +
      Number(val).toLocaleString("en-PH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  };

  return {
    greetingMessage,
    todayGreeting,
    dateFormatMonthDateYear,
    amountFormat,
  };
}
